import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CampaignForm from "./CampaignForm.jsx";
import { getCrmCampaign, updateCrmCampaign } from "@/api/crm.js";
import { useDispatch } from "react-redux";
import { addToast } from "@/store/app/action.js";
import InlineLoader from "@/components/InlineLoader.jsx";

const CampaignFormWrapper = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [initialData, setInitialData] = useState({});
  const [loading, setLoading] = useState(false);

  const isEdit = id && id !== 'new';

  // Fetch campaign data if editing
  useEffect(() => {
    if (isEdit) {
      fetchCampaign();
    }
  }, [id]);

  const fetchCampaign = async () => {
    try {
      setLoading(true);
      const response = await getCrmCampaign(id);
      if (response.status === "success") {
        setInitialData(response.data);
      } else {
        dispatch(addToast({
          type: "error",
          message: "Failed to load campaign",
          timer: 5
        }));
        navigate('/crm/campaigns');
      }
    } catch (err) {
      dispatch(addToast({
        type: "error",
        message: "Failed to load campaign",
        timer: 5
      }));
      navigate('/crm/campaigns');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (payload, shouldClose = true) => {
    try {
      // Only allow updating existing campaigns - no creation
      const response = await updateCrmCampaign(id, payload);

      if (response.status === "success") {
        dispatch(addToast({
          type: "success",
          message: "Campaign updated successfully",
          timer: 5
        }));
        
        if (shouldClose) {
          navigate('/crm/campaigns');
        }
      } else {
        dispatch(addToast({
          type: "error",
          message: "Failed to update campaign",
          timer: 5
        }));
      }
    } catch (err) {
      dispatch(addToast({
        type: "error",
        message: "Failed to update campaign",
        timer: 5
      }));
    }
  };

  const handleCancel = () => {
    navigate('/crm/campaigns');
  };

  if (loading) {
    return (
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full h-full mx-auto relative">
        <InlineLoader message="Loading campaign..." minHeight="h-64" />
      </div>
    );
  }

  return (
    <CampaignForm
      initialData={initialData}
      onSave={handleSave}
      onCancel={handleCancel}
    />
  );
};

export default CampaignFormWrapper;
